import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    List,
    ListItem,
    ListItemAvatar,
    Button,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    TextField,
    Dialog,
    Fade,
    MenuItem,
    CircularProgress,
    Input,
    FormControl,
    InputLabel,
    Select,
    Chip,
    Slide,
    AppBar,
    Toolbar,
    IconButton
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { FacebookShareButton, FacebookIcon, TwitterIcon, EmailIcon, TwitterShareButton, EmailShareButton } from 'react-share';
import { Share, Edit, Close, HighlightOff, Add } from '@material-ui/icons';
import axios from 'axios';
import { getCookies } from '../../utils/getToken.js';
import { SERVER_URL } from '../../utils/config/constants.js';
import DateTimePanel from '../Booking/DateTimePanel.jsx';
import Dropzone from 'react-dropzone';
import { NotificationManager } from 'react-notifications';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});

var formData = new FormData()

const handleDropRejected = (...args) =>
    NotificationManager.error(
        <FormattedMessage
            id="errorUploading"
            defaultMessage="Unable to upload this picture, try another"
        />,
        'Error'
    );

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class MaintenanceList extends React.Component {
    constructor() {
        super();
        this.handleDrop = this.handleDrop.bind(this);
    }
    state = {
        mainData: [],
        showAddMainDialog: false,
        category: "",
        notes: "",
        isImage: false,
        openDateTime: false,
        dateTimeValue: "",
        imageFiles: [],
        loader: true,
        categoryName: '',
        categoryData: [],
        serviceName: [],
        serviceData: [],
        taskName: '',
        taskData: [],
        catId: "",
        serviceId: "",
        taskId: "",
        showEditLogModal: false,
        editableItem: {},
        zoomImageModal: false,
        zoomSrc: "",
        is_system: false,

        imagesToshow: [],
        removingImage: false,
        removeIndex: null,
        isAddingLog: false,
        isUpdating: false

    }
    componentDidMount() {
        this.getMainLog();
        axios({
            method: 'get',
            // url: `${SERVER_URL}/mastercategory/list`,
             url: `${SERVER_URL}/mastercategory/newlist`,
        }).then(resJson => {
            console.log("Categoryyy all data::::", resJson.data.data)
            if (resJson.data.status == "OK") {
                this.setState({
                    categoryData: resJson.data.data,
                })
            }
        })
    }
    getMainLog = () => {
        var authToken = getCookies();
        axios({
            method: 'get',
            url: `${SERVER_URL}/maintenancelog/fetch`,
            headers: { 'x-auth-token': authToken }
        }).then((resJson) => {
            console.log("Resjsonnnn:::", resJson)
            if (resJson.data.status == "OK") {
                this.setState({
                    mainData: resJson.data.data,
                    loader: false
                })
            } else {
                this.setState({
                    mainData: [],
                    loader: false,
                })
            }
        })
    }

    onChangeDate = event => {
        const dateTimeValue = moment(event).format('MM-DD-YYYY');
        this.setState({ openDateTime: true, dateTimeValue: dateTimeValue, openDateTime: false });
    };
    onChangeEditDate = event => {
        console.log("date Edit event::::::::", event)
        const dateTimeValue = moment(event).format('MM-DD-YYYY');
        this.setState({ openDateTime: true, dateTimeValue: dateTimeValue, openDateTime: false }, () => console.log('dateTimeValue', dateTimeValue));
    }
    closeDialog = () => {
        this.setState({
            showAddMainDialog: false
        })
    }
    closeEditDialog = () => {
        this.setState({
            showEditLogModal: false,
            editableItem: {},
            notes: "",
            isImage: false,
            dateTimeValue: "",
            imagesToshow: [],
            imageFiles: [],
            categoryName: "",
            serviceName: "",
            serviceData: [],
            taskName: '',
            taskData: [],
            catId: "",
            serviceId: "",
            taskId: "",
            showEditLogModal: false,
            zoomSrc: "",
        })
    }
    addMainLog = () => {
        this.setState({
            isAddingLog: true
        })
        var authToken = getCookies();
        var fData = new FormData()
        fData.append("category_id", this.state.serviceId)
        fData.append("master_category_id", this.state.catId)
        fData.append("service_id", this.state.taskId)
        fData.append("notes", this.state.notes)
        fData.append("date", moment(this.state.dateTimeValue).format('x'))
        fData.append("is_image", this.state.isImage)

        for (var i = 0; i < this.state.imageFiles.length; i++) {
            fData.append("images", this.state.imageFiles[i])
        }
        axios({
            method: 'post',
            url: `${SERVER_URL}/maintenancelog/create`,
            headers: { 'x-auth-token': authToken },
            data: fData
        }).then((resJson) => {
            console.log("Resjsonnnn:::", resJson)
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.setState({
                    showAddMainDialog: false,
                    isAddingLog: false,
                    imageFiles: []
                })
                this.getMainLog()
            } else {
                NotificationManager.error("Oops!", resJson.data.message)
                this.setState({
                    showAddMainDialog: false,
                    isAddingLog: false,
                    imageFiles: []
                })
            }
        })
    }

    handleDrop(files) {
        files.map(file =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
            })
        )
        console.log('files', files)
        var images = [];
        files.map((file) => {
            if (images.length == 0) {
                images = this.state.imagesToshow.concat(file.preview)
            } else {
                images = images.concat(file.preview)
            }

            console.log('filepath', file.preview)
            console.log('images', images)
        });
        //console.log('images', images)
        this.setState({
            isImage: true,
            imageFiles: this.state.imageFiles.concat(files/* .map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            ) */),
            imagesToshow: images.length > 0 ? images : this.state.imagesToshow
        }, () => console.log('imageFiles', this.state.imageFiles, 'imagesToshow', this.state.imagesToshow))
    }

    handleChangeCategory = (event) => {
        this.setState({
            categoryName: event.target.value,
            catId: event.target.value.key,
            serviceData: event.target.value.categories,
            taskData: [],
            taskName: "",
            serviceName: ""
        })
        console.log("Category Data", event)
    }

    handleChangeService = (event) => {
        this.setState({
            serviceName: event.target.value,
            serviceId: event.target.value.key,
            taskData: event.target.value.services,
            taskName: ""
        })
    }
    handleChangeTask = (event) => {
        this.setState({
            taskName: event.target.value,
            taskId: event.target.value.key
        })
    }
    addDefaultEditValues = (item, index) => {
        console.log("Itemmmm:::", item)
        if (item.master_category_id != null) {
            const categoryObject = this.state.categoryData.filter(singleItem => singleItem.key == item.master_category_id);
            console.log('categoryObject::', categoryObject)
            this.setState({
                editableItem: item,
                categoryName: categoryObject[0],
                catId: item.master_category_id,
                serviceData: categoryObject[0].categories,
            }, () => {
                if (item.category_id != null) {
                    const serviceObject = this.state.serviceData.filter(singleItem => singleItem.key == item.category_id);
                    console.log('serviceObject::', serviceObject)
                    this.setState({
                        serviceName: serviceObject[0],
                        serviceId: item.category_id,
                        taskData: serviceObject[0].services,
                    }, () => {
                        if (item.service_id != null) {
                            const taskObject = this.state.taskData.filter(singleItem => singleItem.key == item.service_id);
                            console.log('taskObject::', taskObject)
                            this.setState({
                                taskName: taskObject[0],
                                taskId: item.service_id,
                                notes: item.notes,
                                isImage: false,
                                dateTimeValue: moment(item.date).format('MM-DD-YYYY'),
                                imagesToshow: item.customer_images,
                                imageFiles: [],
                                categoryData: this.state.categoryData,
                                showEditLogModal: true,
                                zoomSrc: "",
                            })
                        } else {
                            this.setState({
                                notes: item.notes,
                                isImage: false,
                                dateTimeValue: moment(item.date).format('MM-DD-YYYY'),
                                imageFiles: [],
                                imagesToshow: item.customer_images,
                                categoryData: this.state.categoryData,
                                taskName: '',
                                taskId: "",
                                showEditLogModal: true,
                                zoomSrc: "",
                            });
                        }
                    })
                } else {
                    this.setState({
                        notes: item.notes,
                        isImage: false,
                        dateTimeValue: moment(item.date).format('MM-DD-YYYY'),
                        imagesToshow: item.customer_images,
                        imageFiles: [],
                        categoryData: this.state.categoryData,
                        serviceName: "",
                        taskName: '',
                        taskData: [],
                        serviceId: "",
                        taskId: "",
                        showEditLogModal: true,
                        zoomSrc: "",
                    });
                }
            })
        } else {
            this.setState({
                editableItem: item,
                notes: item.notes,
                isImage: false,
                dateTimeValue: moment(item.date).format('MM-DD-YYYY'),
                imagesToshow: item.customer_images,
                imageFiles: [],
                categoryName: "",
                categoryData: this.state.categoryData,
                serviceName: "",
                serviceData: [],
                taskName: '',
                taskData: [],
                catId: "",
                serviceId: "",
                taskId: "",
                showEditLogModal: true,
                zoomSrc: "",
            });
        }
    }
    handleCloseZoomImage = () => {
        this.setState({
            zoomImageModal: false
        })
    }

    removeImage = (item, index) => {
        console.log("Image file:::", item)
        this.setState({ removingImage: true, removeIndex: index })
        const { imageFiles } = this.state;

        var newImagearray = imageFiles.filter(singleItem => singleItem.path !== item.path)
        this.setState({ imageFiles: newImagearray, removingImage: false, removeIndex: null });
    }

    removeLogImage = async (item, index) => {
        console.log("Image file:::", item)
        this.setState({ removingImage: true, removeIndex: index })
        const { imageFiles, imagesToshow } = this.state;
        if (imageFiles.length > 0) {
            var removeFromApi = 1;
            this.state.imageFiles.map((imageitem) => {
                console.log("imageitem", imageitem, "item", item)
                if (imageitem.preview == item) {
                    removeFromApi = 0;
                }
            })
            if (removeFromApi == 1) {
                this.removeImageFromAPI(item, index)
            } else {
                const newImagearray = imageFiles.filter(singleItem => singleItem.preview !== item)
                const newImageNamearray = imagesToshow.filter(singleItem => singleItem !== item)
                this.setState({ imageFiles: newImagearray, imagesToshow: newImageNamearray, removingImage: false, removeIndex: null });
            }
        } else {
            this.removeImageFromAPI(item, index)
        }
    }

    removeImageFromAPI = (item, index) => {
        console.log("removeImageFromAPI", item)
        var authToken = getCookies();
        var fData = new FormData()
        fData.append("log_id", this.state.editableItem.id)
        fData.append("url", item)
        axios({
            method: 'post',
            url: `${SERVER_URL}/maintenancelog/delete-image`,
            data: fData,
            headers: { 'x-auth-token': authToken }
        }).then((resJson) => {
            console.log("Remove response:::", resJson)
            if (resJson.data.status == 'OK') {
                const newImageNamearray = this.state.imagesToshow.filter(singleItem => singleItem !== item)
                this.setState({ imageFiles: this.state.imageFiles, imagesToshow: newImageNamearray, removingImage: false, removeIndex: null });
                NotificationManager.success("Success", resJson.data.message)
            } else {
                this.setState({ removingImage: false, removeIndex: null });
            }
        })
    }

    editMainLog = () => {
        this.setState({
            isUpdating: true
        })
        var authToken = getCookies();
        var fData = new FormData()
        fData.append("log_id", this.state.editableItem.id)
        fData.append("is_system", this.state.is_system)
        fData.append("category_id", this.state.serviceId)
        fData.append("master_category_id", this.state.catId)
        fData.append("service_id", this.state.taskId)
        fData.append("notes", this.state.notes)
        fData.append("date", moment(this.state.dateTimeValue).format('x'))
        fData.append("is_image", this.state.imageFiles.length > 0 ? true : false)

        for (var i = 0; i < this.state.imageFiles.length; i++) {
            fData.append("images", this.state.imageFiles[i])
        }
        axios({
            method: 'post',
            url: `${SERVER_URL}/maintenancelog/edit`,
            headers: { 'x-auth-token': authToken },
            data: fData
        }).then((resJson) => {
            console.log("Resjsonnnn:::", resJson)
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.setState({
                    editableItem: {},
                    notes: "",
                    isImage: false,
                    dateTimeValue: "",
                    imagesToshow: [],
                    imageFiles: [],
                    categoryName: "",
                    serviceName: "",
                    serviceData: [],
                    taskName: '',
                    taskData: [],
                    catId: "",
                    serviceId: "",
                    taskId: "",
                    showEditLogModal: false,
                    zoomSrc: "",
                    isUpdating: false

                })
                this.getMainLog()
            } else {
                NotificationManager.error("Oops!", resJson.data.message)
                this.setState({
                    imageFiles: [],
                    showEditLogModal: true,
                    zoomSrc: "",
                    isUpdating: false

                })
            }
        })
    }

    render() {
        var max = moment().add(0, 'day')

        var valid = function (current) {
            return (max >= current);
        };

        if (this.state.loader) {
            <div style={{ minHeight: '800px' }}>
                <div className={'loader-view loader-center'}>
                    <CircularProgress color="primary" />
                </div>
            </div>
        }

        console.log('dateTimeValuerender', this.state.dateTimeValue)
        return (
            <div className="md-12" style={{ width: "100%" }}>
                <div className="mt-1 md-12 mr-1" style={{ height: 40, justifyContent: "flex-end", display: "flex" }}>
                    <Button variant="contained" color="primary" style={{ width: 120 }} onClick={() => {
                        this.setState({
                            showAddMainDialog: true
                        })
                    }}> Add <Add style={{ marginLeft: 10, width: 22, height: 22 }} />  </Button>
                </div>
                <div className="md-12">
                    {this.state.mainData.length > 0 && this.state.mainData.map((item, index) => {
                        console.log("Item data", item.notes)
                        return (
                            <div className="m-3 p-4 " style={{ boxShadow: "2px 2px 4px #dddddd", borderRadius: 5, backgroundColor: "#ffffff", position: "relative" }}>
                                <Chip style={{
                                    position: "absolute", top: 10, right: 10, borderRadius: 5, color: "#ffffff", backgroundColor:
                                        this.props.colors.SECONDARY.HEX
                                }}
                                    label={!item.is_system ? "My Service Notes" : "ezPro Service Notes"} />
                                {/* {!item.is_system &&  */}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.addDefaultEditValues(item, index)}
                                    style={{
                                        position: "absolute", top: 55, right: 10, background: "#EA9D16", color: "#ffffff",
                                    }}
                                >
                                    Edit
                                </Button>
                                <div className="md-12 row">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }} ><p><b>Date:</b></p></div>
                                    <div className="d-flex col-md-6 " style={{ height: 30, alignItems: "center" }}><p>{moment(item.date).format('MM-DD-YYYY')}</p></div>
                                </div>

                                <div className="md-12 row mt-2">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }}><p><b>Category:</b></p></div>
                                    <div className="d-flex col-md-6" style={{ height: 30, alignItems: "center" }}><p>{item.master_category}</p></div>
                                </div>
                                <div className="md-12 row mt-2">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }}><p><b>Service:</b></p></div>
                                    <div className="d-flex col-md-6" style={{ height: 30, alignItems: "center" }}><p>{item.category}</p></div>
                                </div>
                                <div className="md-12 row mt-2">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }}><p><b>Task:</b></p></div>
                                    <div className="d-flex col-md-6" style={{ height: 30, alignItems: "center" }}><p>{item.service}</p></div>
                                </div>
                                {item.is_system && item.my_notes && item.my_notes != "" && item.my_notes != null &&
                                    <div className="md-12 row mt-2">
                                        <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }}><p><b>My Comments:</b></p></div>
                                        <div className="d-flex col-md-8" style={{ height: 30, alignItems: "center" }}><p>{item.my_notes}</p></div>
                                    </div>
                                }
                                <div className="md-12 row mt-2">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }}><p><b>Notes:</b></p></div>
                                    <div className="d-flex col-md-8" style={{ height: 30, alignItems: "center" }}><p>{item.notes}</p></div>
                                </div>
                                <div className="md-12 mt-2">
                                    {item.customer_images.length > 0 && <p className="mt-1 mb-1"><b>Customer Images:</b></p>}
                                    <div className="md-12 mt-2 row">
                                        {item.customer_images.length > 0 && item.customer_images.map(item => {
                                            return (
                                                <div className="col-md-3 P-2 mt-1 mb-1">
                                                    <img src={item} onClick={() => {
                                                        this.setState({
                                                            zoomImageModal: true,
                                                            zoomSrc: item
                                                        })
                                                    }}
                                                        style={{ width: "100%", height: 120, objectFit: "cover" }} />
                                                </div>
                                            )
                                        })

                                        }
                                    </div>
                                </div>
                                {item.end_provider_images.length > 0 && <div className="md-12 mt-2">
                                    {item.end_provider_images.length > 0 && <p className="mt-1 mb-1"><b>Provider Images:</b></p>}
                                    <div className="md-12 mt-2 row">
                                        {item.end_provider_images.length > 0 && item.end_provider_images.map(item => {
                                            return (
                                                <div className="col-md-3 P-2 mt-1 mb-1">
                                                    <img src={item.small} onClick={() => {
                                                        this.setState({
                                                            zoomImageModal: true,
                                                            zoomSrc: item.large
                                                        })
                                                    }}
                                                        style={{ width: "100%", height: 120, objectFit: "cover" }} />
                                                </div>
                                            )
                                        })

                                        }
                                    </div>
                                </div>}

                            </div>
                        )
                    })
                    }
                </div>
                {this.state.showAddMainDialog &&
                    <Dialog
                        TransitionComponent={Fade}
                        disableBackdropClick={false}
                        className="service-suggestion-modal md-4 align-self-center"
                        open={this.state.showAddMainDialog}
                        onClose={this.closeDialog}
                        aria-labelledby="form-dialog-title"
                    >
                        <div style={{ backgroundColor: "white" }} className="custom-input-text col p-3">
                            <form className="form-new">
                                <div className="col-md-12 mt-1">
                                    <DateTimePanel
                                        className="login-form-textfield"
                                        open={
                                            this.state
                                                .openDateTime
                                        }
                                        isValidDate={valid}
                                        timeFormat={false}
                                        onChange={
                                            this.onChangeDate
                                        }
                                        value={
                                            this.state
                                                .dateTimeValue
                                        }
                                    />
                                </div>

                                <div className="col-md-4">
                                    <FormControl
                                        className="w-100 login-form-textfield form-control" style={{
                                            backgroundColor: "#f9f9f9",
                                            borderTop: "1px solid #0078ff"
                                        }}
                                    >
                                        <Select
                                            style={{ background: "#f9f9f9" }}
                                            className="login-form-textfield form-control"
                                            autoWidth={true}
                                            value={this.state.categoryName}
                                            onChange={this.handleChangeCategory.bind(this)}
                                            input={<Input id="categoryId" />}
                                        >
                                            {this.state.categoryData.map((category, index) => {
                                                return (
                                                    <MenuItem
                                                        value={category}
                                                        key={index}
                                                    >
                                                        {category.heading}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>

                                        {this.state.categoryName == "" &&
                                            <p style={{ position: "absolute", fontSize: 14, fontWeight: 800, left: 5, top: 10, color: "#0078ff" }}>Select Category</p>}

                                    </FormControl>

                                </div>
                                <div className="col-md-4">
                                    <FormControl
                                        className="w-100 login-form-textfield form-control"
                                        style={{
                                            backgroundColor: "#f9f9f9",
                                            borderTop: "1px solid #0078ff"
                                        }}
                                    >
                                        <Select
                                            style={{ background: "#f9f9f9" }}
                                            className="login-form-textfield form-control"
                                            autoWidth={true}
                                            value={this.state.serviceName}
                                            onChange={this.handleChangeService.bind(this)}
                                            input={<Input id="categoryId" />}
                                        >
                                            {this.state.serviceData.map((service, index) => {
                                                return (
                                                    <MenuItem
                                                        value={service}
                                                        key={index}
                                                    >
                                                        {service.heading}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                        {this.state.serviceName == "" &&
                                            <p style={{ position: "absolute", fontSize: 14, fontWeight: 800, left: 5, top: 10, color: "#0078ff" }}>Select Service</p>}
                                    </FormControl>

                                </div>

                                <div className="col-md-4">
                                    <FormControl
                                        className="w-100 login-form-textfield form-control"
                                        style={{
                                            backgroundColor: "#f9f9f9",
                                            borderTop: "1px solid #0078ff"
                                        }}
                                    >
                                        <Select
                                            style={{ background: "#f9f9f9" }}
                                            className="login-form-textfield form-control"
                                            autoWidth={true}
                                            value={this.state.taskName}
                                            onChange={this.handleChangeTask.bind(this)}
                                        >
                                            {this.state.taskData.map((task, index) => {
                                                return (
                                                    <MenuItem
                                                        value={task}
                                                        key={index}
                                                    >
                                                        {task.heading}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>

                                        {this.state.taskName == "" &&
                                            <p style={{ position: "absolute", fontSize: 14, fontWeight: 800, left: 5, top: 10, color: "#0078ff" }}>Select Task</p>}
                                    </FormControl>

                                </div>

                                {/* <TextField id="standard-basic" label="Service Name" className="login-form-textfield"
                                style={{ marginTop: 10 }}
                                fullWidth onChange={event => {
                                    this.setState({
                                        category: event.target.value,
                                    });
                                }} /> */}
                                <div className="col-md-12 mt-2">
                                    <TextField id="standard-basic" className="login-form-textfield"
                                        style={{}} label="notes" fullWidth onChange={event => {
                                            this.setState({
                                                notes: event.target.value,
                                            });
                                        }} />
                                </div>

                                <div className="col-md-12 mt-4">
                                    <h4 style={{ marginBottom: 20 }}>
                                        <b>
                                            Add Images
                                                            </b>
                                    </h4>
                                    <div className="drop-box" style={{ marginBottom: 20 }}>
                                        <Dropzone
                                            onDrop={this.handleDrop}
                                            accept="image/jpeg,image/jpg,image/png"
                                            multiple={true}
                                            maxSize={2097152}
                                            onDropRejected={handleDropRejected}
                                        >
                                            {({ getRootProps, getInputProps }) => (
                                                <div {...getRootProps()}>
                                                    <input {...getInputProps()} />
                                                    <p>
                                                        <FormattedMessage
                                                            id="customer.dropfiles"
                                                            defaultMessage="Drop files here, or click to select files"
                                                        />
                                                    </p>
                                                </div>
                                            )}
                                        </Dropzone>
                                    </div>

                                    {this.state.imageFiles.length > 0 && this.state.imageFiles.map((file, index) => {
                                        console.log("Files:::::::", file)
                                        return (
                                            <div className="col-md-3 P-2 mt-1 mb-4 d-flex" style={{ justifyContent: "center", marginTop: 25, marginBottom: 25 }}
                                                key={index}>
                                                <img src={file.preview} style={{ height: 100, width: "100%" }} />
                                                <HighlightOff style={{ position: "absolute", bottom: -25, color: "red" }}
                                                    onClick={() => {
                                                        this.removeImage(file, index)
                                                    }} />
                                            </div>
                                        )
                                    })}
                                </div>

                            </form>
                            <div className="d-flex justify-content-center col-md-12">
                                {this.state.isAddingLog ? <CircularProgress /> :
                                    <button type="button" class="custom-button"
                                        onClick={() => {
                                            this.addMainLog()
                                        }}>ADD MAINTENANCE LOG</button>}
                            </div>
                        </div>

                    </Dialog>
                }
                {this.state.showEditLogModal &&
                    <Dialog
                        TransitionComponent={Fade}
                        disableBackdropClick={false}
                        className="service-suggestion-modal md-4 align-self-center"
                        open={this.state.showEditLogModal}
                        onClose={this.closeEditDialog}
                        aria-labelledby="form-dialog-title"
                    >
                        <div style={{ backgroundColor: "white" }} className="custom-input-text col p-3">
                            <form className="form-new">
                                <div className="col-md-12 mt-1">

                                    {this.state.editableItem.is_system ? <TextField id="standard-basic" className="login-form-textfield"
                                        style={{ marginBottom: 20 }} disabled={true}
                                        fullWidth value={moment(this.state.dateTimeValue).format('MM-DD-YYYY')}

                                    /> : <DateTimePanel
                                            className="login-form-textfield"
                                            open={
                                                this.state.openDateTime
                                            }
                                            isValidDate={valid}
                                            timeFormat={false}
                                            onChange={
                                                this.onChangeEditDate
                                            }
                                            value={
                                                this.state.dateTimeValue
                                            }
                                            defaultValue={
                                                moment(this.state.dateTimeValue).format('MM-DD-YYYY')
                                            }
                                        />}
                                </div>

                                <div className="col-md-4">
                                    <FormControl
                                        className="w-100 login-form-textfield form-control" style={{
                                            backgroundColor: "#f9f9f9",
                                            borderTop: "1px solid #0078ff"
                                        }}
                                    >
                                        <Select
                                            style={{ background: "#f9f9f9" }}
                                            className="login-form-textfield  form-control"
                                            autoWidth={true}
                                            defaultValue={this.state.categoryName}
                                            value={this.state.categoryName}
                                            onChange={this.handleChangeCategory.bind(this)}
                                            disabled={this.state.editableItem.is_system ? true : false}
                                        >
                                            {this.state.categoryData.map((category, index) => {
                                                return (
                                                    <MenuItem
                                                        value={category}
                                                        key={index}
                                                    >
                                                        {category.heading}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>

                                </div>
                                <div className="col-md-4">
                                    <FormControl
                                        className="w-100 login-form-textfield  form-control"
                                        style={{
                                            backgroundColor: "#f9f9f9",
                                            borderTop: "1px solid #0078ff"
                                        }}
                                    >
                                        <Select
                                            style={{ background: "#f9f9f9" }}
                                            className="login-form-textfield  form-control"
                                            autoWidth={true}
                                            value={this.state.serviceName}
                                            onChange={this.handleChangeService.bind(this)}
                                            defaultValue={this.state.serviceName}
                                            disabled={this.state.editableItem.is_system ? true : false}

                                        >
                                            {this.state.serviceData.map((service, index) => {
                                                return (
                                                    <MenuItem
                                                        value={service}
                                                        key={index}
                                                    >
                                                        {service.heading}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>

                                </div>

                                <div className="col-md-4">
                                    <FormControl
                                        className="w-100 login-form-textfield  form-control"
                                        style={{
                                            backgroundColor: "#f9f9f9",
                                            borderTop: "1px solid #0078ff"
                                        }}
                                    >
                                        <InputLabel style={{ backgroundColor: "#f9f9f9" }} htmlFor="categoryId">Tasks</InputLabel>
                                        <Select

                                            style={{ background: "#f9f9f9" }}
                                            className="login-form-textfield  form-control"
                                            autoWidth={true}
                                            value={this.state.taskName}
                                            onChange={this.handleChangeTask.bind(this)}
                                            defaultValue={this.state.taskName}
                                            disabled={this.state.editableItem.is_system ? true : false}


                                        >
                                            {this.state.taskData.map((task, index) => {
                                                return (
                                                    <MenuItem
                                                        value={task}
                                                        key={index}
                                                    >
                                                        {task.heading}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>

                                </div>

                                <div className="col-md-12 mt-2">
                                    <TextField id="standard-basic" className="login-form-textfield"
                                        style={{}} label={this.state.editableItem.is_system ? "Add Comment" : "note"}
                                        placeholder={this.state.editableItem.is_system ? "Add Comment" : "note"}
                                        fullWidth value={this.state.notes} onChange={event => {
                                            this.setState({
                                                notes: event.target.value,
                                            });
                                        }}
                                    />
                                </div>

                                <div className="col-md-12 mt-4">
                                    <h4 style={{ marginBottom: 20 }}>
                                        <b>
                                            Add Images
                                        </b>
                                    </h4>
                                    <div className="drop-box" style={{ marginBottom: 20 }}>
                                        <Dropzone
                                            onDrop={this.handleDrop}
                                            accept="image/jpeg,image/jpg,image/png"
                                            multiple={true}
                                            maxSize={2097152}
                                            onDropRejected={handleDropRejected}
                                        >
                                            {({ getRootProps, getInputProps }) => (
                                                <div {...getRootProps()}>
                                                    <input {...getInputProps()} />
                                                    <p>
                                                        <FormattedMessage
                                                            id="customer.dropfiles"
                                                            defaultMessage="Drop files here, or click to select files"
                                                        />
                                                    </p>
                                                </div>
                                            )}
                                        </Dropzone>
                                    </div>

                                    {this.state.imagesToshow.length > 0 && this.state.imagesToshow.map((file, index) => {
                                        console.log("Files:::::::", file)
                                        return (
                                            <div className="col-md-3 P-2 mt-1 mb-4 d-flex" style={{ justifyContent: "center", marginTop: 25, marginBottom: 25 }}
                                                key={index}>
                                                <img src={file} style={{ height: 100, width: "100%" }} />
                                                <HighlightOff style={{ position: "absolute", bottom: -25, color: "red" }}
                                                    onClick={() => {
                                                        this.removeLogImage(file, index)
                                                    }} />
                                            </div>
                                        )
                                    })}
                                </div>

                            </form>
                            <div className="d-flex justify-content-center col-md-12">
                                {this.state.isUpdating ? <CircularProgress /> :
                                    <button type="button" class="custom-button"
                                        onClick={() => {
                                            this.editMainLog()
                                        }}>UPDATE</button>}
                            </div>
                        </div>

                    </Dialog>
                }

                {this.state.zoomImageModal && <Dialog PaperProps={{
                    style: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                    },
                }}
                    fullScreen={true} style={{ background: "transparent" }} open={this.state.zoomImageModal}
                    onClose={this.handleCloseZoomImage} TransitionComponent={Transition}>
                    <AppBar style={{ position: "relative" }}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={this.handleCloseZoomImage} aria-label="close">
                                <Close />
                            </IconButton>

                        </Toolbar>

                    </AppBar>
                    <div className="d-flex justify-content-center" style={{
                        width: "100%", height: "100%",
                        background: "rgba(0,0,0,0.2)", alignContent: "center", alignItems: "center"
                    }}>
                        <Zoom wrapStyle={{ background: null }}>
                            <img alt="crop" src={this.state.zoomSrc} width={500}
                                /* style={{ width: 600, height: 700, }} */ />
                        </Zoom>
                    </div>
                </Dialog>}
            </div>
        );
    }
}

const mapStateToProps = ({ settings, auth }) => {
    return {
        colors: settings.colors,
        settings: settings,
        userData: auth.userData
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(mapStateToProps, actions)
);

export default composedComponent(MaintenanceList);



// WEBPACK FOOTER //
// ./src/components/Customer/MaintenanceList.jsx